import { render, staticRenderFns } from "./OneVillageOneProduct.vue?vue&type=template&id=23ce7500&scoped=true&"
import script from "./OneVillageOneProduct.vue?vue&type=script&lang=js&"
export * from "./OneVillageOneProduct.vue?vue&type=script&lang=js&"
import style0 from "./OneVillageOneProduct.vue?vue&type=style&index=0&id=23ce7500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ce7500",
  null
  
)

export default component.exports